<template>
    <div class="container-fluid">
        <h1>{{$t('components.shopord.title')}}</h1>
        <div class="row">
            <div class="col-sm-12">
                <div class="row">
                    <div class="container-fluid bg-white shadow-sm">
                        <section class="mb-5">
                            <div class="row mt-4">
                                <div class="col-sm-12 col-md-3 border-right">
                                    <h5 class="text-center">{{$t('components.stocklist.filters')}}</h5>
                                    <hr>
                                    <button class="btn btn-sm btn-wos-real w-100" @click="clearFilters">
                                        {{$t('components.stocklist.btnClearFilters')}}
                                    </button>
                                    <div class="row mt-2">
                                        <div class="col-sm-12">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{$t('components.stocklist.filterProducts')}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect onhover" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(item, index) in productFilters" :key="index" class="mb-2">
                                                        <label><input type="checkbox" v-model="item.checked" :value="item.value"/>
                                                            {{item.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card mt-2">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{$t('components.shopord.needweek') | capitalize}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect onhover" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(item, index) in readinessFilters" :key="index" class="mb-2">
                                                        <label><input type="checkbox" v-model="item.checked" :value="item.value"/>
                                                            {{$t('components.shopord.readyWeek', {num: item.value})}}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card mt-2">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{$t('components.stocklist.warehouse') | capitalize}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect onhover" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(item, index) in warehouseFilters" :key="index" class="mb-2">
                                                        <label><input type="checkbox" v-model="item.checked" :value="item.value"/>
                                                            {{item.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card mt-2" v-for="(item, index) in characteristicFilters" :key="index">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{item.name}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(characteristic, index2) in item.values" :key="index2" class="mb-2">
                                                        <label><input type="checkbox" v-model="characteristic.checked" :value="characteristic.option_value_id"/>
                                                            {{characteristic.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-9">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4 text-wellis-gold">
                                            {{$t('components.stocklist.dataLength', {len: dataLength, time: fetchTimeComputed})}}
                                        </div>
                                        <div class="col-sm-12 offset-md-4 col-md-4">
                                            <input class="form-control form-control-sm mb-2" type="text" :placeholder="$t('components.topbar.search')" v-model="quickSearch"/>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="row">
                                                <div class="col-sm-12 w-100" style="overflow-x: scroll">
                                                    <table class="table  table-striped table-hover">
                                                        <thead>
                                                        <th>{{$t('components.stocklist.name') | capitalize}}</th>
                                                        <th>{{$t('components.products.catalogNoShort') | capitalize}}</th>
                                                        <th>{{$t('components.stocklist.configNoShort') | capitalize}}</th>
                                                        <th>{{$t('components.products.quantity') | capitalize}}</th>
                                                        <th>{{$t('components.products.price') | capitalize}}</th>
                                                        <th>{{$t('components.stocklist.acrylicColor') | capitalize}}</th>
                                                        <th>{{$t('components.stocklist.cabinetColor') | capitalize}}</th>
                                                        <th>{{$t('components.shopord.needweek') | capitalize}}</th>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="item in filteredResults" :key="item.uniqueId"
                                                            class="">
                                                            <td>
                                                                <router-link class="text-wellis-gold font-weight-bold" :to="{name: 'app.shopord.view', params: {
                                                                    uniqueId: item.uniqueId
                                                                }}">
                                                                    {{item.name | cut}}
                                                                </router-link>
                                                            </td>
                                                            <td>
                                                                <router-link :to="{name: 'app.shopord.view', params: {
                                                                    uniqueId: item.uniqueId
                                                                }}">
                                                                    {{item.catalogNo}}
                                                                </router-link>
                                                            </td>
                                                            <td class="text-wellis-gold font-weight-bold">{{item.configNo}}</td>
                                                            <td>{{`${item.quantity} ${item.unit}`}}</td>
                                                            <td class="text-wellis-gold font-weight-bold">
                                                                <div v-if="hasPrice(item)">
                                                                    <small class="text-black-50 d-block" v-if="item.price.vat">
                                                                        {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, false)}} + {{$t('components.products.vat')}}
                                                                    </small>
                                                                    {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, item.price.vat)}}
                                                                </div>
                                                                <div v-else>
                                                                    -
                                                                </div>
                                                            </td>
                                                            <td>{{item.acrylicColor}}</td>
                                                            <td>{{item.cabinetColor}}</td>
                                                            <td>{{item.needWeek}}.</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {__clone, empty} from "../../../helpers";
    import {EVENT_LANG_CHANGE} from "@/core/constants";
    import ShopOrdApiService from "../../../api/shopord.api";

    export default {
        name: "ShopOrd",

        mounted() {
            if (!this.$store.getters['configStore/getShopOrdModuleStatus']) {
                return this.$router.push({name: 'app.start'});
            }

            if (this.$store.getters['authStore/fromUSA']) {
                return this.$router.push({
                    name: 'app.start'
                });
            }

            if (this.$route.query.product) {
                let products = JSON.parse(this.$route.query.product);
                if (products instanceof Array && products.length > 0) {
                    this.queryFiltering = true;
                    this.$set(this.queryFilters, 'product', products);
                }
            }

            if (this.$route.query.characteristics) {
                let characteristics = JSON.parse(this.$route.query.characteristics);
                if (characteristics instanceof Object) {
                    this.queryFiltering = true;
                    this.$set(this.queryFilters, 'characteristics', characteristics);
                }
            }

            this.bootstrap();
            this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
                this.bootstrap();
            });
        },

        destroyed() {
            this.$eventBus.$off(EVENT_LANG_CHANGE);
        },

        data() {
            return {
                shopord: [],
                quickSearch: null,
                filters: {
                    category: [],
                    product: [],
                    warehouse: [],
                    readiness: [],
                    characteristics: []
                },
                fetchTime: 0,
                queryFiltering: false,
                queryFilters: {
                    category: [],
                    product: [],
                    warehouse: [],
                    readiness: [],
                    characteristics: []
                }
            }
        },
        methods: {
            bootstrap(filters = null) {
                let loader = this.$loading.show();
                let fetchStartTime = Date.now();
                ShopOrdApiService.getShopOrd(filters)
                    .then(response => {
                        this.$set(this, 'shopord', Object.values(response.data.shopOrd));
                        if (filters === null) {
                            this.filters.product = response.data.filters.product;
                            this.filters.warehouse = response.data.filters.warehouse;
                            this.filters.readiness = response.data.filters.readiness;
                            this.filters.characteristics = Object.values(response.data.filters.characteristics);
                            if (this.hasQueryFilter) {
                                let filters = __clone(this.queryFilters);
                                this.queryFilters = {
                                    category: [],
                                    product: [],
                                    warehouse: [],
                                    readiness: [],
                                    characteristics: []
                                };
                                this.queryFiltering = false;
                                this.toggleFilters(filters);
                                this.applyFilters();
                            } else {
                                this.$scrollTop();
                            }
                        }
                        this.fetchTime = Date.now() - fetchStartTime;
                    })
                    .catch(() => {
                        this.$swal.fire({
                            icon: "error",
                            allowOutsideClick: false,
                            html: this.$t('components.shopord.notready')
                        });
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            },

            clearFilters() {
                this.filters.product.map(item => item.checked = false);
                this.filters.characteristics.map(item => item.values.map(char => char.checked = false));
                this.bootstrap();
            },

            applyFilters() {
                let filters = {
                    product: [],
                    warehouse: [],
                    readiness: [],
                    characteristics: {},
                };
                this.filters.product.map(item => {
                    if (item.checked) {
                        filters.product.push(item.value);
                    }
                });

                this.filters.warehouse.map(item => {
                    if (item.checked) {
                        filters.warehouse.push(item.value);
                    }
                });

                this.filters.readiness.map(item => {
                    if (item.checked) {
                        filters.readiness.push(item.value);
                    }
                });

                this.filters.characteristics.map(char => {
                    char.values.map(item => {
                        if (item.checked) {
                            if (typeof filters.characteristics[char.characteristic_id] === 'undefined') {
                                filters.characteristics[char.characteristic_id] = [];
                            }
                            filters.characteristics[char.characteristic_id].push(item.option_value_id);
                        }
                    })
                });

                this.bootstrap(filters);
            },

            toggleFilters(filters) {
                filters.product.map(x => {
                    let product = this.filters.product.find(item => item.value === x);
                    if (product) {
                        product.checked = true;
                    }
                });

                for (const [key, value] of Object.entries(filters.characteristics)) {
                    let char = this.filters.characteristics.find(item => item.characteristic_id === key);
                    if (char) {
                        value.forEach(val => {
                            let opt = char.values.find(item => item.option_value_id === val);
                            if (opt) {
                                opt.checked = true;
                            }
                            console.log(key, value, char, opt);
                        });
                    }
                }

            }
        },

        computed: {
            shopOrd() {
                return this.shopord;
            },

            filteredResults() {
                let items = [];
                this.shopOrd.forEach(item => {
                    if (!empty(this.quickSearch)) {
                        let r = new RegExp(this.quickSearch, "iu");
                        if (r.test(item.name) || r.test(item.catalogNo)) {
                            items.push(item);
                        }
                    } else {
                        items.push(item);
                    }
                });

                items.sort(function (a, b) {
                    return a.needWeek > b.needWeek;
                });

                return items;
            },

            productFilters() {
                return this.filters.product;
            },

            characteristicFilters() {
                return this.filters.characteristics;
            },

            hasPrice() {
                return item => {
                    return item.price && typeof item.price !== 'undefined';
                }
            },

            warehouseFilters() {
                return this.filters.warehouse;
            },

            readinessFilters() {
                return this.filters.readiness;
            },

            dataLength() {
                return this.shopOrd.length;
            },

            fetchTimeComputed() {
                return (Math.abs(this.fetchTime) / 1000).toFixed(2);
            },

            hasQueryFilter() {
                return this.queryFiltering;
            }
        }
    }
</script>

<style scoped>
    .text-sm {
        font-size: 13px;
    }

    input[type="checkbox"] {
        opacity: 1;
    }
</style>
